import React, { Component } from "react";
import Menu from "../contianer/Menu/Menu";
import { connect } from "react-redux";
import { modalStatusToggle, mobileLogin } from "../store/action/index";
import Hoc from "../Hoc/Hoc";
import log from "../assets/logo.svg";
import globalCss from "../global.css";
import classes from "./Layout.css";
import Footer from "../component/Footer/Footer";
import Modal from "../UI/Modal/Modal";
import MobileSign from "../contianer/MobileSign/MobileSign";
import Alerty from "../UI/Alerty/Alerty";

class Layout extends Component {
  state = {
    scrollTop: false,
    Top: true,
    ShowMenu: false
  };

  componentDidMount = () => {
    if (localStorage["LOG_IN_WITH_PHONE"]) {
      this.props.mobileLogin(localStorage["CELL_PHONE"]);
    }
    let oldScroll = window.scrollY;
    window.onscroll = e => {
      let scrollY = window.scrollY;
      // print "false" if direction is down and "true" if up
      if (oldScroll > scrollY) {
        this.setState(
          {
            scrollTop: true
          },
          () => {
            if (scrollY < 80) {
              this.setState({
                Top: true
              });
            }
          }
        );
      } else {
        this.setState({
          scrollTop: false,
          Top: false
        });
      }
      oldScroll = scrollY;
    };
  };

  ToggleMenuShow = () => {
    this.setState(prevState => {
      return {
        ShowMenu: !prevState.ShowMenu
      };
    });
  };

  componentWillReceiveProps = props => {
    if (props.Platform) {
      this.setState({
        ShowMenu: false
      });
    }
  };

  render() {
    return (
      <Hoc>
        <Alerty />
        {this.state.ShowMenu ? (
          <div className={classes.ShowMEnuMobile}>
            <div className={classes.ShowContent}>
              <p className={classes.CloseBtn} onClick={this.ToggleMenuShow}>
                <span className={classes.CloseBar} />
                <span className={classes.CloseBar} />
              </p>
              <Menu />
            </div>
          </div>
        ) : null}
        {this.props.showToggle ? (
          <Modal
            click={() => this.props.modalStatusToggle()}
            CloseToggl={this.props.showToggle}
          >
            {this.props.Platform === "MOBILE" ? (
              <MobileSign
                loginStatus={() => this.props.mobileLogin()}
                Autoclose={() => this.props.modalStatusToggle()}
              />
            ) : null}
          </Modal>
        ) : null}
        <div className={this.props.showToggle ? classes.blur : null}>
          <div className={classes.headerIcon} onClick={this.ToggleMenuShow}>
            <p className={classes.MenuBar} />
            <p className={classes.MenuBar} />
            <p className={classes.MenuBar} />
            <p className={classes.MenuBar} />
          </div>
          <header
            id="MENU"
            className={
              this.state.scrollTop
                ? this.state.Top
                  ? null
                  : classes.Showcontrol
                : this.state.Top
                ? null
                : classes.HideHeader
            }
          >
            <div className={globalCss.Responsive}>
              <Menu />
              <div className={classes.logopart}>
                <img src={log} alt="logo Mehrab" className={classes.Logo} />
                <span style = {{color : "#0006b6"}}> محراب سیر کیش </span>
              </div>
            </div>
          </header>
          <main>{this.props.children}</main>
          <footer>
            <Footer />
          </footer>
        </div>
      </Hoc>
    );
  }
}

const mapStateToProps = state => {
  return {
    showToggle: state.UI.showToggle,
    Platform: state.UI.Platform,
    SMS: state.ALERT.SMS
  };
};

const mapDispatchToProps = dispatch => {
  return {
    modalStatusToggle: () => dispatch(modalStatusToggle()),
    mobileLogin: mobile => dispatch(mobileLogin(mobile))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);
